import KformComponent from '../kform-component';
import { createComponentInstance } from '../kform-component-class';

export default class WellComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentWell | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.input = false;
		this.components = settings?.components
			? settings.components.map((/** @type {any} */ c) => createComponentInstance(c))
			: [];
	}
}
